import classes from './SectionTittleH3.module.scss';

const SectionTitleH3 = (props) => {
    return <div className={classes.sectionTitleH3}>{props.children}</div>;
};

export default SectionTitleH3;
